import { Container, Row, Col, Card } from 'react-bootstrap';
import CommitteeMembers from './committee-members';
import TeamSessionResultsContainer from './team-session-results-container';
import IndividualResultTableContainer from './individual-result-table-container';
import type { UpcomingEvent, CommitteeMember } from '../types/api.types';
import type { MemberLookupFn } from '../utils/committee';
import './styles.css';

interface HomePageProps {
  lastIndividualCompId: string | undefined;
  lastTeamCompId: string | undefined;
  upcomingEvents: UpcomingEvent[];
  committeeMembers: CommitteeMember[];
  memberLookup: MemberLookupFn;
}

export const HomePage = ({
  lastIndividualCompId,
  lastTeamCompId,
  upcomingEvents,
  committeeMembers,
  memberLookup,
}: HomePageProps) => {
  return (
    <Container>
      <Row>
        <Col md={4}>
          <Card>
            <Card.Header>Welcome</Card.Header>
            <Card.Body>
              <div style={{ textAlign: 'center' }}>This is the home of the Crazy English Golf Society.</div>
              <img src="/assets/Crazy English Logo - Grey.svg" height="100%" width="100%" alt="Crazy English" />
            </Card.Body>
          </Card>
        </Col>
        <Col md={8}>
          <CommitteeMembers
            committeeMembers={committeeMembers}
            memberLookup={memberLookup}
            upcomingEvents={upcomingEvents}
          />
        </Col>
      </Row>
      <Row>
        {lastIndividualCompId == null ? null : (
          <Col md={6}>
            <IndividualResultTableContainer comp_id={lastIndividualCompId} />
          </Col>
        )}
        {lastTeamCompId == null ? null : (
          <Col md={6}>
            <TeamSessionResultsContainer comp_id={lastTeamCompId} />
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default HomePage;
